var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDirectMailCostPerPatient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: 173.872,
    viewBox: "0 0 320.105 173.872",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_781",
    "data-name": "Group 781",
    transform: "translate(-56.895 -156.636)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_134",
    "data-name": "$134",
    transform: "translate(80.367 248.769)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -22.461,
    y: 0
  }, "$134")), /*#__PURE__*/React.createElement("text", {
    id: "_267",
    "data-name": "$267",
    transform: "translate(80.367 207.201)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -22.461,
    y: 0
  }, "$267")), /*#__PURE__*/React.createElement("text", {
    id: "_400",
    "data-name": "$400",
    transform: "translate(79.895 166.636)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -22.461,
    y: 0
  }, "$400")), /*#__PURE__*/React.createElement("text", {
    id: "_0",
    "data-name": 0,
    transform: "translate(80.367 290.337)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5.615,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    id: "May",
    transform: "translate(191.267 309.537)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.451,
    y: 0
  }, "May")), /*#__PURE__*/React.createElement("text", {
    id: "Mar",
    transform: "translate(140.854 308.537)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.777,
    y: 0
  }, "Mar")), /*#__PURE__*/React.createElement("text", {
    id: "Jan",
    transform: "translate(93.158 309.537)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.237,
    y: 0
  }, "Jan")), /*#__PURE__*/React.createElement("text", {
    id: "Month",
    transform: "translate(230.28 327.508)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -14.363,
    y: 0
  }, "Month")), /*#__PURE__*/React.createElement("text", {
    id: "Sep",
    transform: "translate(292.303 309.537)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.42,
    y: 0
  }, "Sep")), /*#__PURE__*/React.createElement("text", {
    id: "Jul",
    transform: "translate(242.009 309.537)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6.729,
    y: 0
  }, "Jul")), /*#__PURE__*/React.createElement("text", {
    id: "Nov",
    transform: "translate(341.541 309.537)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.801,
    y: 0
  }, "Nov")), /*#__PURE__*/React.createElement("text", {
    id: "Jun",
    transform: "translate(216.677 308.537)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.274,
    y: 0
  }, "Jun")), /*#__PURE__*/React.createElement("text", {
    id: "Apr",
    transform: "translate(166.099 309.537)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -7.759,
    y: 0
  }, "Apr")), /*#__PURE__*/React.createElement("text", {
    id: "Feb",
    transform: "translate(115.612 309.537)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.218,
    y: 0
  }, "Feb")), /*#__PURE__*/React.createElement("text", {
    id: "Oct",
    transform: "translate(317.544 309.537)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -7.688,
    y: 0
  }, "Oct")), /*#__PURE__*/React.createElement("text", {
    id: "Aug",
    transform: "translate(267.065 308.537)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.796,
    y: 0
  }, "Aug")), /*#__PURE__*/React.createElement("text", {
    id: "Dec",
    transform: "translate(368 309.537)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.545,
    y: 0
  }, "Dec")), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    y1: 134.491,
    transform: "translate(92.678 163.636)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    y1: 134.491,
    transform: "translate(141.261 163.636)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    y1: 134.491,
    transform: "translate(191.807 163.636)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    y1: 134.491,
    transform: "translate(242.352 163.636)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    y1: 134.491,
    transform: "translate(292.899 163.636)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    y1: 134.491,
    transform: "translate(342.019 163.636)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    y1: 134.491,
    transform: "translate(115.988 163.636)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    y1: 134.491,
    transform: "translate(166.534 163.636)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    "data-name": "Line 10",
    y1: 134.491,
    transform: "translate(217.08 163.636)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    "data-name": "Line 11",
    y1: 134.491,
    transform: "translate(267.625 163.636)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_12",
    "data-name": "Line 12",
    y1: 134.491,
    transform: "translate(315.661 163.636)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_13",
    "data-name": "Line 13",
    y1: 134.491,
    transform: "translate(368.377 163.636)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_14",
    "data-name": "Line 14",
    x2: 283.459,
    transform: "translate(84.541 247.06)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_15",
    "data-name": "Line 15",
    x2: 283.459,
    transform: "translate(84.541 205.48)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_16",
    "data-name": "Line 16",
    x2: 283.459,
    transform: "translate(84.541 163.9)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_17",
    "data-name": "Line 17",
    x2: 283.459,
    transform: "translate(84.541 288.641)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1862",
    "data-name": "Group 1862",
    transform: "translate(87.565 173.204)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 4.619,
    cy: 4.619,
    rx: 4.619,
    ry: 4.619,
    transform: "translate(276.248 32.391)",
    fill: "#b94f4f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 4.619,
    cy: 4.619,
    rx: 4.619,
    ry: 4.619,
    transform: "translate(252.757 21.594)",
    fill: "#b94f4f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 4.619,
    cy: 4.619,
    rx: 4.619,
    ry: 4.619,
    transform: "translate(227.466 30.232)",
    fill: "#b94f4f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 4.619,
    cy: 4.619,
    rx: 4.619,
    ry: 4.619,
    transform: "translate(202.175 10.797)",
    fill: "#b94f4f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 4.619,
    cy: 4.619,
    rx: 4.619,
    ry: 4.619,
    transform: "translate(176.884 25.913)",
    fill: "#b94f4f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 4.619,
    cy: 4.619,
    rx: 4.619,
    ry: 4.619,
    transform: "translate(151.594 37.79)",
    fill: "#b94f4f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    cx: 4.619,
    cy: 4.619,
    rx: 4.619,
    ry: 4.619,
    transform: "translate(126.302 10.797)",
    fill: "#b94f4f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 4.619,
    cy: 4.619,
    rx: 4.619,
    ry: 4.619,
    transform: "translate(101.011 6.478)",
    fill: "#b94f4f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 4.619,
    cy: 4.619,
    rx: 4.619,
    ry: 4.619,
    transform: "translate(75.721 26.993)",
    fill: "#b94f4f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 4.619,
    cy: 4.619,
    rx: 4.619,
    ry: 4.619,
    transform: "translate(52.815 19.435)",
    fill: "#b94f4f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 4.619,
    cy: 4.619,
    rx: 4.619,
    ry: 4.619,
    transform: "translate(26.408 0)",
    fill: "#b94f4f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 4.619,
    cy: 4.619,
    rx: 4.619,
    ry: 4.619,
    transform: "translate(0 19.435)",
    fill: "#b94f4f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M491.809,280.407,466.7,269.61l-25.113,8.638-25.114-19.435-25.113,15.116-25.113,11.877-25.113-26.993-25.113-4.319L290.9,275.009l-25.113-7.558-25.113-19.435-25.113,19.435",
    transform: "translate(-123.377 -70.194)",
    fill: "none",
    stroke: "#b94f4f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectMailCostPerPatient);
export default __webpack_public_path__ + "static/media/directMailCostPerPatient.7f88f627.svg";
export { ForwardRef as ReactComponent };